export interface IDdocIndexerResponse {
  _id: string;
  portalAddress: string;
  registryAddress: string;
  tokenId: number;
  fileId: number;
  metadataIPFSHash: string;
  contentIPFSHash: string;
  gateIPFSHash: null;
  fileType: string;
  by: string;
  editedBy: string;
  isDeleted: boolean;
  lastTransactionHash: string;
  lastTransactionBlockNumber: number;
  lastTransactionBlockTimestamp: number;
  createdBlockTimestamp: number;
  __v: number;
  ddocId: string;
  resolvedMetadata: ResolvedMetadata;
}

export interface ResolvedMetadata {
  title: string;
  size: number;
  mimeType: string;
  portalLock: Lock;
  ownerLock: Lock;
  linkLock: Lock;
  ddocId: string;
  nonce: string;
  owner: string;
  archVersion: string;
  version: string;
}

export interface Lock {
  lockedFileKey: string;
  lockedChatKey: string;
  lockedLinkKey: string;
}

type GetDdocsByPortalAddressResponse = {
  ddocs: IDdocIndexerResponse[];
  hasNext: boolean;
  total: number;
  unique: number;
};

export const getDdocsByPortalAddress = async (
  portalAddress: string,
  skip?: number,
  limit?: number
): Promise<GetDdocsByPortalAddressResponse> => {
  const url = `${process.env.NEXT_PUBLIC_INDEXER_API}/ddoc?skip=${skip || 0}&limit=${limit || 10}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      contract: portalAddress,
    },
  });

  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }

  return res.json();
};
